import React, {useMemo} from "react";
import {useDeskStore} from "../../../api/DeskStore";
import {DashboardWidget, DashboardWidgetItem} from "../DashboardWidget";
import {AppPages, usePageUrl} from "../../../app-layout/AppPages";
import DeskChip from "../../../components/desk-chip/DeskChip";
import EmployeeAvatar from "../../../components/employee-avatar/EmployeeAvatar";
import EmployeeLink from "../../../components/employee-link/EmployeeLink";
import {Desks_Read} from "../../../util/access/Permission";
import {CsvModel} from "../../../util/CSVWriteUtil";
import {RemoteValue} from "../../../util/RemoteValue";
import {Desk} from "../../../api/Model";
import {useFixDesksAssignedToInactiveEmployees} from "./useFixDesksAssignedToInactiveEmployees";

const desksAssignedToInactiveEmployeesCsvModel = RemoteValue.fromValue(new CsvModel<Desk>([
    {header: 'Desk', value: desk => desk.name},
    {header: 'Room', value: desk => desk.roomName},
    {header: 'Person', value: desk => desk.assignedTo?.fullName ?? ''},
]));

export function DesksAssignedToInactiveEmployeesWidget() {
    const pageUrl = usePageUrl();
    const desks = useDeskStore(state => state.remoteValue);
    const problems = useMemo(() => desks.map(items => items.filter(desk => desk.assignedTo?.deactivated === true)), [desks]);
    const fixAction = useFixDesksAssignedToInactiveEmployees(problems);

    return (
        <DashboardWidget
            title="Desks assigned to inactive employees"
            description="Former employees should not occupy a desk in the office. Here is the list of employees deactivated in Hibob but still having desks assigned to them."
            problems={problems}
            requiredPermissions={Desks_Read}
            link={pageUrl(AppPages.desks, {}, {problem: 'inactive-employee'})}
            csvModel={desksAssignedToInactiveEmployeesCsvModel}
            fixAction={fixAction}
            renderProblem={(desk, index) => (
                <DashboardWidgetItem
                    key={desk.id}
                    index={index}
                    left={desk.assignedTo && (
                        <>
                            <DeskChip desk={desk} deskAssignee={desk.assignedTo} hideAssignee size="small"/>
                            <EmployeeAvatar employee={desk.assignedTo} sx={{width: 24, height: 24}}/>
                            <EmployeeLink employee={desk.assignedTo}/>
                        </>
                    )}
                />
            )}
        />
    );
}
